export default __webpack_public_path__ + "media/ccc62e9808a36189224f5e45b70efaacbbf8437b950437c8b2942fa3bbd2d5eb.svg";